<ng-container *transloco="let t; read: 'toolbar.smart-command'">
  <button
    mat-icon-button
    (click)="openSmartCommandDialog()"
    [matTooltip]="t('btn-tooltip')"
  >
    <mat-icon svgIcon="terminal_icon"></mat-icon>
  </button>
</ng-container>
